import { render, staticRenderFns } from "./MassInfo.vue?vue&type=template&id=540f3ccd&scoped=true&"
import script from "./MassInfo.vue?vue&type=script&lang=js&"
export * from "./MassInfo.vue?vue&type=script&lang=js&"
import style0 from "./MassInfo.vue?vue&type=style&index=0&id=540f3ccd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f3ccd",
  null
  
)

export default component.exports